export function isNorwegianMobile(input: string | undefined | null): boolean {
  return /^[49]\d{7}$/.test(input ?? "");
}